<template>
    <div class="contents">
        <div class="flexd">
            <div class="container">
                <div class="title">
                    {{ $store.state.title }}
                </div>
                <div class="nav">
                    <div class="nav_left " :class="indexs == 0 ? 'nav_button' : ''" @click="SetChane(0)">
                        代金券
                    </div>
                    <div class="nav_right " :class="indexs == 1 ? 'nav_button' : ''" @click="SetChane(1)">
                        团购套餐
                    </div>
                </div>
                <div class="table">
                    <table class="tables" width="100%">
                        <tr class="table_one">
                            <td class="one">名称</td>
                            <td class="tow">数量</td>
                            <td class="three">金额</td>
                        </tr>
                        <tr v-for="(itme, index) in tableData" :key="index" v-if="indexs == 0">
                            <td class="one">{{ itme.voucherbasename }}</td>
                            <td class="tow">{{ itme.qty }}</td>
                            <td class="three">￥{{ itme.amount }}</td>
                        </tr>
                        <tr v-for="(itme, index) in tableData" :key="index" v-if="indexs == 1">
                            <td class="one">{{ itme.productname }}</td>
                            <td class="tow">{{ itme.qty }}</td>
                            <td class="three">￥{{ itme.payamount }}</td>
                        </tr>

                    </table>
                </div>

            </div>
            <div class="buuton" @click="SetPageIfg">
                <img src="../../assets/关闭.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import { deepClone } from '../../utils/Shenfunction/index.js'
export default {
    data() {
        return {
            tableData: [
                {
                    date: '95代100代金券',
                    name: 1,
                    address: 95
                },
                {
                    date: '45代50代金券',
                    name: 2,
                    address: 90
                },
                {
                    date: "合计",
                    name: 3,
                    address: 185
                }
            ],
            tableData1: [
                {
                    date: '95代100代金券',
                    name: 1,
                    address: 95
                },
                {
                    date: '45代50代金券',
                    name: 2,
                    address: 90
                },
                {
                    date: "合计",
                    name: 3,
                    address: 185
                }
            ],
            tableData2: [
                {
                    date: '1-4人团购价',
                    name: 1,
                    address: 95
                },
                {
                    date: '2-4人团购价',
                    name: 2,
                    address: 90
                },
                {
                    date: "合计",
                    name: 3,
                    address: 185
                }
            ],
            indexs: 0,
            mtvoucherzou: {
                voucherbasename: "合计",
                qty: 10,
                amount: 5000
            },
            mtsetmealzou: {
                productname: "合计",
                qty: 10,
                payamount: 5000
            }
        }
    },
    methods: {
        SetPageIfg() {
            this.$store.commit('SetPageIfg', false)
            document.body.style.overflow = 'auto';
        },
        SetChane(index) {
            this.indexs = index
            this.tableData = index === 0 ? this.tableData1 : this.tableData2
        }
    },
    mounted() {
        //修改待金券
        this.tableData1 = deepClone(this.$store.state.TopData.mtvoucher)
        //添加小数点
        this.mtvoucherzou.qty = 0
        let qtys = 0
        let money = 0
        this.tableData1.forEach(element => {
            qtys = qtys + Number(element.qty)
            element.amount = (element.amount).toFixed(2)
            money = money + Number(element.amount)
        });
        this.mtvoucherzou.qty = qtys
        this.mtvoucherzou.amount = money.toFixed(2)
        this.tableData1.push(this.mtvoucherzou)
        this.tableData = deepClone(this.tableData1)
        this.tableData2 = deepClone(this.$store.state.TopData.mtsetmeal)
        let qtys1 = 0
        let money1 = 0
        this.tableData2.forEach(element => {
            qtys1 = qtys1 + Number(element.qty)
            element.payamount = (element.payamount).toFixed(2)
            money1 = money1 + Number(element.payamount)
        });
        this.mtsetmealzou.qty = qtys1
        this.mtsetmealzou.payamount = money1.toFixed(2)
        this.tableData2.push(this.mtsetmealzou)


    },
    beforeDestroy() {
        //修改待金券
        this.$store.commit('SetTopData', {})
    },
}
</script>
<style lang="scss" scoped>
@import '../../assets/hotcss/hotcss-master/src/px2rem.scss';

.contents {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.50);
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;

    top: 0;
}

.table_one {
    color: #6F6F6F;
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
}

.container {

    width: 100%;
    border-radius: 10px;
    background: #FFF;
    padding: 16px 16px 32px 16px;


    .title {
        display: flex;
        justify-content: center;
        color: #333;
        font-family: Alibaba PuHuiTi;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
    }

    .nav {
        display: flex;
        margin-top: 16px;
        color: #000;
        font-family: Alibaba PuHuiTi;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        justify-content: space-evenly;
        border-bottom: 1px solid #EEE;
    }

    .nav_button {
        border-bottom: 2px solid #C2986E;
    }

    .table {
        margin-top: 16px;
        color: #333;
        font-family: Alibaba PuHuiTi 3.0;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        border: 1px solid #DDDDDD;
        border-bottom: 0; // 去除下边框
        border-radius: 2px;
        max-height: 250px;
        overflow: auto;

        table {
            // border: 1px solid #DDD;
            border-collapse: collapse;


        }

        // color: #333;
        // font-family: Alibaba PuHuiTi;
        // font-size: 14px !important;
        // font-style: normal;
        // font-weight: 400;
        tr {
            height: 32px;

            td {
                border-bottom: 1px solid #DDD;
                padding-left: 12px;
            }
        }
    }
}

.buuton {
    margin-top: 24px;
}

.flexd {
    position: fixed;
    top: 25%;
    max-width: 410px;
    width: 80%;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>